import Vue from 'vue';
import { Module } from 'vuex';
import { ActionContext, DefineActions, DefineMutations } from 'vuex-type-helper';
import { EventBus } from '../../helpers/bus';
import { RootState } from '../index';

export interface ModuleState {
    isScriptLoaded: boolean;
    isScriptReady: boolean;
    components: Vue[];
}

export interface ModuleActions {
    loadScript: void;
}

export interface ModuleMutations {
    setScriptLoaded: boolean;
}

const state: ModuleState = {
    isScriptLoaded: false,
    isScriptReady: false,
    components: [],
};

const mutations: DefineMutations<ModuleMutations, ModuleState> = {
    setScriptLoaded(s: ModuleState, isLoaded): void {
        s.isScriptLoaded = !!isLoaded;
        s.isScriptReady = !!isLoaded;
        EventBus.$emit('youTubeIframeAPIReady');
    },
};

const actions: DefineActions<ModuleActions, ModuleState, ModuleMutations> = {
    loadScript(s: ActionContext<ModuleState, {}, ModuleActions, ModuleMutations>): void {
        if (s.state.isScriptLoaded === false) {
            if (window.YT && window.YT.loaded) {
                s.commit('setScriptLoaded', true);
                return;
            }
            (window as any).onYouTubeIframeAPIReady = () => {
                s.commit('setScriptLoaded', true);
            };
            const script = document.createElement('script');
            script.setAttribute('src', 'https://www.youtube.com/iframe_api');
            document.body.appendChild(script);
        }
    },
};

const module: Module<ModuleState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/youTube.ts